module.exports = __webpack_public_path__ + "mirus_header_image_2.jpg";